module.exports = "pegasus_template/assets/tech/welcome/101.png";